<template>
  <!-- BEGIN: Weekly Top Products -->
  <div class="col-span-12 mt-6">
    <div class="intro-y block sm:flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-5">Workshop Requests</h2>
      <div class="flex items-center sm:ml-auto mt-3 sm:mt-0">
        <button
            class="button box flex items-center text-gray-700 dark:text-gray-300"
        >
          <FileTextIcon class="hidden sm:block w-4 h-4 mr-2" />
          Export to Excel
        </button>
        <button
            class="ml-3 button box flex items-center text-gray-700 dark:text-gray-300"
        >
          <FileTextIcon class="hidden sm:block w-4 h-4 mr-2" />
          Export to PDF
        </button>
      </div>
    </div>
    <div class="intro-y overflow-auto lg:overflow-visible mt-8 sm:mt-0">
      <table class="table table-report sm:mt-2">
        <thead>
        <tr>
          <th class="whitespace-no-wrap">IMAGES</th>
          <th class="whitespace-no-wrap">NAME</th>
          <th class="text-center whitespace-no-wrap">STOCK</th>
          <th class="text-center whitespace-no-wrap">STATUS</th>
          <th class="text-center whitespace-no-wrap">ACTIONS</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="dat in data"
            :key="dat.id"
            class="intro-x"
        >
          <td class="w-40">
            <div class="flex">
              <div class="w-10 h-10 image-fit zoom-in">
<!--                <Tippy-->
<!--                    tag="img"-->
<!--                    alt="Midone Tailwind HTML Admin Template"-->
<!--                    class="rounded-full"-->
<!--                    :src="require(`@/assets/images/${faker.images[0]}`)"-->
<!--                    :content="`Uploaded at ${faker.dates[0]}`"-->
<!--                />-->
              </div>
              <div class="w-10 h-10 image-fit zoom-in -ml-5">
<!--                <Tippy-->
<!--                    tag="img"-->
<!--                    alt="Midone Tailwind HTML Admin Template"-->
<!--                    class="rounded-full"-->
<!--                    :src="require(`@/assets/images/${faker.images[1]}`)"-->
<!--                    :content="`Uploaded at ${faker.dates[1]}`"-->
<!--                />-->
              </div>
              <div class="w-10 h-10 image-fit zoom-in -ml-5">
<!--                <Tippy-->
<!--                    tag="img"-->
<!--                    alt="Midone Tailwind HTML Admin Template"-->
<!--                    class="rounded-full"-->
<!--                    :src="require(`@/assets/images/${faker.images[2]}`)"-->
<!--                    :content="`Uploaded at ${faker.dates[2]}`"-->
<!--                />-->
              </div>
            </div>
          </td>
          <td>
            <a href="" class="font-medium whitespace-no-wrap">{{
                dat.name
              }}</a>
            <div class="text-gray-600 text-xs whitespace-no-wrap">
              {{ dat.duration }}
            </div>
          </td>
          <td class="text-center">{{ dat.description }}</td>
          <td class="w-40">
            <div
                class="flex items-center justify-center"
                :class="{
                      'text-theme-9': dat.name.length > 5,
                      'text-theme-6': dat.name.length <= 5
                    }"
            >
              <CheckSquareIcon class="w-4 h-4 mr-2" />
              {{ dat.name.length > 5 ? "Active" : "Inactive" }}
            </div>
          </td>
          <td class="table-report__action w-56">
            <div class="flex justify-center items-center">
              <a class="flex items-center mr-3" href="">
                <CheckSquareIcon class="w-4 h-4 mr-1" />
                Edit
              </a>
              <a class="flex items-center text-theme-6" href="">
                <Trash2Icon class="w-4 h-4 mr-1" /> Delete
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div
        class="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3"
    >
      <ul class="pagination">
        <li>
          <a class="pagination__link" href="">
            <ChevronsLeftIcon class="w-4 h-4" />
          </a>
        </li>
        <li>
          <a class="pagination__link" href="">
            <ChevronLeftIcon class="w-4 h-4" />
          </a>
        </li>
        <li>
          <a class="pagination__link" href="">...</a>
        </li>
        <li>
          <a class="pagination__link" href="">1</a>
        </li>
        <li>
          <a class="pagination__link pagination__link--active" href="">2</a>
        </li>
        <li>
          <a class="pagination__link" href="">3</a>
        </li>
        <li>
          <a class="pagination__link" href="">...</a>
        </li>
        <li>
          <a class="pagination__link" href="">
            <ChevronRightIcon class="w-4 h-4" />
          </a>
        </li>
        <li>
          <a class="pagination__link" href="">
            <ChevronsRightIcon class="w-4 h-4" />
          </a>
        </li>
      </ul>
      <select class="w-20 input box mt-3 sm:mt-0">
        <option>10</option>
        <option>25</option>
        <option>35</option>
        <option>50</option>
      </select>
    </div>
  </div>
  <!-- END: Weekly Top Products -->
</template>

<script>
export default {
  props: ["data"]
}
</script>